<template>
  <div class="not-found">
    <h1>404</h1>
    <p>La página que buscas no existe.</p>
    <QBtn variant="confirma" label="Volver al inicio" class="mt-3" @click="$router.push('/dashboard')" />
  </div>
</template>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
}
.not-found h1 { font-size: 5rem; font-weight: 800; color: var(--q-text); margin-bottom: 0.5rem; }
.not-found p  { font-size: 1.1rem; color: var(--q-muted); }
</style>
